
import HelpCenterNav from "@/components/layout/navigation/HelpCenterNav"
import { routeToDatenschutz } from "@/helpers/routing"
export default {
    layout: "fullscreen",
    components: {
        HelpCenterNav,
    },
    props: {
        navTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            routeToDatenschutz,
            showNavbar: true,
            lastScrollPosition: 0,
        }
    },
    mounted() {
        if (process.client) {
            window.addEventListener("scroll", this.handleScroll)
        }
    },
    beforeDestroy() {
        if (process.client) {
            window.removeEventListener("scroll", this.handleScroll)
        }
    },
    methods: {
        handleScroll() {
            const currentScrollPosition =
                window.pageYOffset || document.documentElement.scrollTop
            if (currentScrollPosition < 0) {
                return
            }
            this.showNavbar = currentScrollPosition < this.lastScrollPosition
            this.lastScrollPosition = currentScrollPosition
        },
    },
}
